<template>
  <v-app class="appWrapper" color="orange">
    <Menu />
    <v-toolbar class="dashboardHeader" v-if="showAdminUI" flat color="grey darken-3" style="height:64px!important;" @click="navigate('/admin')">
      <v-card flat class="grey darken-3 white--text">
        <v-layout row wrap>
          <v-flex xs12>
            <h1 class="title">MCTC Admin Dashboard</h1>
          </v-flex>
        </v-layout>
      </v-card>
    </v-toolbar>
    <v-navigation-drawer v-if="showAdminUI" app permanent absolute width="250">
      <v-list class="dashboardList">
        <v-list-tile v-for="link in links" :key="link.name" @click="navigate(link.path)">
          <v-list-tile-action>
            <v-icon>{{link.icon}}</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>{{link.name}}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <Content />
    <Footer />
    <!-- <adminDashboard v-if="showAdminUI" /> -->
    <!-- <site v-else /> -->
    <!-- <adminMenu v-show="showAdminUI"/>
    <mainMenu v-show="!showAdminUI"/>
    <mainMenu v-show="showAdminUI"/> -->
    <!-- <v-content padding=0 >
      <v-container fluid pa-0>
        <router-view/>
      </v-container>
    </v-content>
    <mainFooter :isAdmin="showAdminUI"/> -->
  </v-app>
</template>

<script>
import Vue from 'vue'
// import AdminMenu from '@/components/MenuAdmin'
// // import Menu from '@/components/Menu'
// import Banner from '@/components/SplashBanner'
// import Footer from '@/components/Footer'
// import admin from '@/views/admin'
import MenuWrapper from '@/ui/MenuWrapper'
import ContentWrapper from '@/ui/ContentWrapper'
import FooterWrapper from '@/ui/FooterWrapper'

import { components } from 'aws-amplify-vue'

Vue.component('Menu', MenuWrapper)
Vue.component('Content', ContentWrapper)
Vue.component('Footer', FooterWrapper)

export default {
  name: 'app',
  computed: {
    showAdminUI () {
      return this.$route.meta.requiresAdmin || false
    }
  },
  data () {
    return {
      links: [
        {
          name: 'Dashboard',
          path: '/admin',
          icon: 'home'
        },
        {
          name: 'Members',
          path: '/admin/members',
          icon: 'people'
        },
        // {
        //   name: 'Riders',
        //   path: '/admin/riders',
        //   icon: 'people'
        // },
        {
          name: 'Track Duty Roster',
          path: '/admin/duty',
          icon: 'event'
        }
        // {
        //   name: 'News',
        //   path: '/admin/news',
        //   icon: 'event_note'
        // },
        // {
        //   name: 'Emails',
        //   path: '/admin/emails',
        //   icon: 'email'
        // }
      ]
    }
  },
  methods: {
    navigate (path) {
      this.$router.push(path)
    }
  },
  components: {
    ...components
  }
}
</script>
<style>
.appWrapper {
  width: 100%;
  max-width: 100%;
}
.dashboardHeader {
  position: fixed;
  border-radius: 0px;
  height: 64px;
  width: 300px;
  z-index: 5;
  top:0;
  left:0;
}
.dashboardList {
  margin-top: 64px;
}
</style>
